import gql from 'graphql-tag'

const query = gql`
query listProducts($filter: ProductFilterArgs $params: ListQueryArgs) {
	cashAssist {
		listProducts(filter: $filter, params: $params) {
			items {
				name
				id
				code
				price
				category {
					id
					color
				}
			}
			cursors {
				hasNext
				hasPrevious
				before
				after
			}
			hasNextPage
		}
	}
}`

export default query
